// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import App from './App';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import Dashboard from './components/Dashboard/Dashboard';
import ChatInterface from './components/Chat/ChatInterface';
import { config } from './config/config';
import { contentService } from './services/contentService';
import { loginRedirect, logoutRedirect, handleAuthReturn, isAuthenticated, hasAttemptedRedirect, initializeMsal } from './services/authService';
import { UserCircleIcon } from "@heroicons/react/24/solid";
import './index.css';

const App = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Set document title from config
    document.title = config.app.name;
    
    const initAuth = async () => {
      try {
        await initializeMsal();
        const authUser = await handleAuthReturn();
        setUser(authUser);
        
        // Auto-redirect only if enabled, no user, and haven't attempted redirect yet
        if (config.features.enableSSO && config.features.autoRedirect && !authUser && !hasAttemptedRedirect()) {
          loginRedirect();
          return;
        }
      } catch (error) {
        console.error('Auth initialization failed:', error);
      } finally {
        setIsLoading(false);
      }
    };

    initAuth();
  }, []);

  const handleLogin = () => loginRedirect();
  const handleLogout = async () => {
    await logoutRedirect();
    setUser(null);
  };

  const toggleChat = () => setIsChatOpen(!isChatOpen);
  const closeChat = () => setIsChatOpen(false);

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="App">
      {config.features.enableSSO ? (
        user ? (
          <>
            <Dashboard 
              onChatToggle={toggleChat} 
              user={{ 
                name: user?.displayName || 'User', 
                displayName: user?.displayName || 'User', 
                email: user?.email || '',
                photoUrl: user?.photoUrl || null,
                image: <UserCircleIcon className="w-10 h-10 text-gray-400" /> 
              }} 
              onLogout={handleLogout} 
            />
            {config.features.enableChat && <ChatInterface isOpen={isChatOpen} onClose={closeChat} />}
          </>
        ) : (
          <div className="login-container">
            <div className="login-background-animation"></div>
            <div className="login-card">
              <div className="login-card-header">
                <img 
                  src="images/tiles/logoask2.png" 
                  alt={contentService.getLoginConfig().logo_alt} 
                  className="login-logo" 
                />
                <div className="login-welcome-badge">
                  <i className="fas fa-shield-alt"></i>
                  <span>{contentService.getLoginConfig().badge_text}</span>
                </div>
              </div>
              <div className="login-card-content">
                <h1 className="login-title">
                  {contentService.getLoginConfig().title}
                </h1>
                <p className="login-subtitle">
                  {contentService.getLoginConfig().subtitle}
                </p>
                <div className="login-features">
                  <div className="feature-item">
                    <i className="fas fa-robot"></i>
                    <span>{contentService.getLoginConfig().features[0]}</span>
                  </div>
                  <div className="feature-item">
                    <i className="fas fa-chart-line"></i>
                    <span>{contentService.getLoginConfig().features[1]}</span>
                  </div>
                  <div className="feature-item">
                    <i className="fas fa-shield-alt"></i>
                    <span>{contentService.getLoginConfig().features[2]}</span>
                  </div>
                </div>
                <button onClick={handleLogin} className="login-button">
                  <i className="fab fa-microsoft"></i>
                  <span>{contentService.getLoginConfig().button_text}</span>
                  <i className="fas fa-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        )
      ) : (
        <>
          <Dashboard 
            onChatToggle={toggleChat} 
            user={{ name: contentService.getDashboardConfig().guest_user, image: <UserCircleIcon className="w-10 h-10 text-gray-400" /> }} 
          />
          {config.features.enableChat && <ChatInterface isOpen={isChatOpen} onClose={closeChat} />}
        </>
      )}
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
